<template>
  <div id="memory" class="carousel-container" >
    <br>
    <!-- <el-carousel :interval="4000" height="475px" width="20px" indicator-position="outside" class="scaled-carousel"> -->
    <el-carousel v-if="!isMobile" :interval="4000" height="475px" width="300px" indicator-position="outside" class="scaled-carousel">
      <el-carousel-item v-for="item in memory_img" :key="item.id">
        <img :src="item.url" class="image" alt="" style="height: 100%;width: 100%; object-fit: fill">
      </el-carousel-item>
    </el-carousel>

    <!-- 小屏幕下的内容 -->
    <el-carousel
      v-else
      :interval="4000"
      height="200px"
      width="1000px"
      indicator-position="outside"

    >
      <el-carousel-item v-for="item in memory_img" :key="item.id">
        <img :src="item.url" class="image" alt="" style="height: 100%; width: 100%; object-fit: fill" />
      </el-carousel-item>
    </el-carousel>

    <div class="welcome-text">
      Welcome to Xiangyu Li Lab
    </div>
  </div>



</template>

<script>
export default {
  name: 'Memory',
  data () {
    return {
      isMobile: false,
      memory_img: [
        {id: 0, url: require('../assets/all_people.jpg')},
        {id: 1, url: require('../assets/memory1.jpg')}
      ],
      student_info: ['霍玉莹（2021级学硕）', '薛辉杰（2022级学硕）', '王嘉康（2022级专硕）', '高梦楠（2022级专硕）', '王金霞（2023级专硕）', '王  琛（2023级专硕）']
    }
  },
  mounted() {
    // 初始化屏幕宽度检测
    this.checkScreenSize();
    // 监听窗口大小变化
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      // 判断屏幕宽度是否小于768px
      this.isMobile = window.innerWidth < 768;
    }
  }

}
</script>

<style scoped>



.scaled-carousel /deep/ .el-carousel__arrow {
  font-size: 60px;
  width: 40px;
  height: 50px;
  line-height: 50px;
  background-color: rgba(0, 0, 0, 0);
  color: white;
  opacity: 1 !important;
  visibility: visible !important;
  transition: background-color 0.3s, color 0.3s;
}

.scaled-carousel /deep/ .el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0);
  color: #005BAC;
}

.scaled-carousel /deep/ .el-carousel__arrow--left,
.scaled-carousel /deep/ .el-carousel__arrow--right {
  border-radius: 0%;
}

.titles {
  color: #005BAC;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
}

.carousel-container {
  margin: auto;
  width: 678px;
  height: auto;
  position: relative;

}

.welcome-text {
  position: absolute;
  width: 94%;
  top: 83.5%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  font-size: 24px;
  color: white;
  background-color: rgba(0, 91, 172, 0.5);
  padding: 10px 20px;
  border-radius: 5px;
}


/* 额外的样式（可选） */
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

 /* 手机端的样式 */
@media (max-width: 768px) {


  .desktop-carousel {
    display: none; /* 隐藏桌面版本 */
  }

  .mobile-carousel {

    display: block; /* 显示移动版本 */
  }

  .welcome-text {
    font-size: 18px; /* 调整文本大小 */
  }


  /* 这些都是绘制好的了的 不用动 */
  .scaled-carousel /deep/ .el-carousel__arrow {
  font-size: 25px;
  width: 10px;
  height: 30px;
  line-height: 50px;
  background-color: rgba(0, 0, 0, 0);
  color: white;
  opacity: 1 !important;
  visibility: visible !important;
  transition: background-color 0.3s, color 0.3s;
}

.scaled-carousel /deep/ .el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0);
  color: #005BAC;
}

.scaled-carousel /deep/ .el-carousel__arrow--left,
.scaled-carousel /deep/ .el-carousel__arrow--right {
  border-radius: 0%;
}

.titles {
  color: #005BAC;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
}

.carousel-container {
  position: relative;
  width: 275px;
  height: 250px;
}

.welcome-text {
  position: absolute;
  width: 86%;
  top: 79%;
  left: 50%;
  /* transform: translateX(-50%); */
  z-index: 10;
  font-size: 12px;
  color: white;
  background-color: rgba(0, 91, 172, 0.5);
  padding: 5px 20px;
  border-radius: 5px;
}


/* 额外的样式（可选） */
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
}



</style>



// WEBPACK FOOTER //
// src/components2/Memory.vue